const round2 = (n: number) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

export interface Totals {
  subtotal: number;
  gst: number;
  total: number;
}

/**
 * The figures under a proposal's price table (the same arithmetic as the server, so the editor shows what the customer
 * will see). GST added on top, or worked back from amounts typed with GST included; with no GST rate the typed sum is
 * the indicative total.
 */
export function proposalTotals(typed: number, rate: number | null | undefined, includesGst: boolean): Totals {
  const sum = round2(typed);
  if (rate === null || rate === undefined || !(Number(rate) >= 0)) return { subtotal: sum, gst: 0, total: sum };
  const r = Number(rate) / 100;
  if (includesGst) {
    const subtotal = round2(sum / (1 + r));
    return { subtotal, gst: round2(sum - subtotal), total: sum };
  }
  const gst = round2(sum * r);
  return { subtotal: sum, gst, total: round2(sum + gst) };
}

/** Payment milestones as rupee amounts of the total; the last row takes what is left so they add up exactly */
export function paymentAmounts(rows: Array<{ label: string; percent: number }>, total: number) {
  let left = round2(total);
  return rows.map((r, i) => {
    const amount = i === rows.length - 1 ? left : Math.min(left, round2((total * Number(r.percent)) / 100));
    left = round2(left - amount);
    return { label: r.label, percent: Number(r.percent), amount };
  });
}

export const GST_RATES = [0, 5, 12, 18, 28];
